const rotations = new Map();

// An explicit correction in this session takes precedence over recognition.
export function pdfRotation(fingerprint, automatic = 0, page = 1) {
    return rotations.get(`${fingerprint}:${page}`) ?? automatic;
}

export function rememberPdfRotation(fingerprint, rotation, page = 1) {
    // Bounded session preferences contain no PDF data, URLs or credentials.
    if (rotations.size >= 32) rotations.delete(rotations.keys().next().value);
    rotations.set(`${fingerprint}:${page}`, rotation);
}
